export const ERROR_PERMISSIONS_LIST = 'permissions/error-permissions-list';
export const RECEIVE_PERMISSIONS_LIST = 'permissions/receive-permissions-list';
export const REQUEST_PERMISSIONS_LIST = 'permissions/request-permissions-list';
export const RESTART_STATE = 'permissions/restart-state';
export const SET_ERROR = 'permissions/set-error';
export const SET_MASK = 'permissions/set-mask';
export const SET_SELECTED_ROW = 'permissions/set-selected-row';
export const UPDATE_DATA_TABLE = 'permissions/update-data-table';
export const UPDATE_FIELD_FILTER = 'permissions/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'permissions/update-table-column';